import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import GridSpinner from 'components/UI/GridSpinner'

const LayoutSuspense = ({ children = null }) => (
  <Suspense fallback={<GridSpinner />}>{children}</Suspense>
)

LayoutSuspense.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
}

export default LayoutSuspense
